import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, throwError } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';

export type allyears = 'True' | null;
export type allgroups = 'True' | null;

@Injectable({
    providedIn: 'root'
})
export class OverallStatsService {

    private base_url: string;

    private weeklyStats: BehaviorSubject<any[]> = new BehaviorSubject([])
    public weeklyStats$ = this.weeklyStats.asObservable();

    constructor(private http: HttpClient, private authService: AuthService) {
        this.base_url = environment.base_url;
    }

    public setWeeklyStatsData(weeklyStats) {
        this.weeklyStats.next(weeklyStats)
    }

    /**
     * Get overall Sensor Stats
     * @param 
     * @returns sensors : Sensor[]
     */
    getOverallStats({ allYears, allGroups, year, group }: { allYears?: allyears, allGroups?: allgroups, year?: string | number | null, group?: string | number | null }) {
        let specificParams = `year=${year}&group=${group}`
        let overallParams = `allyears=${allYears}&allgroups=${allGroups}`

        let url = `${this.base_url}/api/overallstat?`

        if (allYears !== null && allGroups !== null) {
            url += overallParams
        }
        if (allYears !== null && allGroups === null && group !== null) {
            url += `allyears=${allYears}&group=${group}`
        }

        if (allYears === null && allGroups !== null && year !== null) {
            url += `year=${year}&allgroups=${allGroups}`
        }

        if (allYears === null && allGroups === null) {
            url += specificParams
        }

        return this.http.get(url)
            .pipe(
                retry(2),
                map(res => {
                    if (res) return res['data']
                }),
                catchError(err => {
                    return throwError(err)
                })
            )
    }
}


